import { useState } from "react";
import { useSettingsStore } from "@/features/settings/hooks";

export type Device = "mobile" | "desktop";

/**
 * UA から device を判定する。
 *
 * - iPhone / Android phone / Windows Phone 等 → mobile
 * - iPad (iPadOS 13+ では Mac 偽装) → desktop
 * - Android Tablet → desktop (Figma `Desktop and Tablet` セクションに従う)
 * - PC → desktop
 */
function detectByUA(): Device {
  if (typeof navigator === "undefined") return "desktop";
  const ua = navigator.userAgent;
  const isMobileUA =
    /Android|iPhone|iPod|Mobile|Opera Mini|webOS|Windows Phone/i.test(ua);
  const isIPadOnIOS =
    /iPad/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  return isMobileUA && !isIPadOnIOS ? "mobile" : "desktop";
}

/**
 * 現在の device を返す。
 *
 * - 設定の `deviceOverride` が `'auto'` 以外なら強制適用
 * - `'auto'` のときは UA 検知 (`detectByUA`)
 * - 値は **mount 時に 1 回固定**。リロードまで変更されない（override 変更時は
 *   設定 UI 側でリロードを促す helper text を出す）
 */
export function useDevice(): Device {
  const override = useSettingsStore((s) => s.deviceOverride);
  const [device] = useState<Device>(() =>
    override === "auto" ? detectByUA() : override,
  );
  return device;
}
